import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  showPleaseWait: false,
  bonusPhasesNum: 0,
  monthlyButton: true,
  grandButton: true,
  weeklyButton: true,
  allWinners: [],
  performanceInfo: {},
  gameTypeWinnersForLeaderboard: [],
  gameTypeRankForLeaderboard: [],
  achievements: [],
  achievementNotificationData: [],
  phaseBonusModalToBeDisplayed: {},
  phaseBonusList: [],
  bonusDailyModal: null,
  totalWinners: 0,
  monthlyWin: [],
  grandWin: [],
  instantWin: [],
  jackpotRankData: [],
  jackpotPrizes: [],
  checkedNotificationId: '',
  checkedNotificationReadStatus: false,
  notificationPrizeWon: false,
  notificationRewardId: '',
  notificationRewardName: '',
  hashedPass: null,
  twoStepVerificationWrongPin: null,
  twoStepVerificationServerError: null,
  twoStepVerificationVerified: null,
  forgotPasswordInfo: '',
  prizes: {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    GRAND: 'GRAND',
  },
  showmodalForRanking: {
    userLevel: '',
    bonusPoints: '',
    gamesEarned: '',
  },
  moreWinnersButton: false,
  moreWinnersMButton: false,
  moreWinnersIButton: false,
  numberOfTotalPrizes: 5,
  extraArraysWinners: [],
  visitorWinners: [],
  monthlyPrize: {},
  grandPrize: {},
  dailyPrize: {},
  weeklyPrize: {},
  carouselPrizes: [],
  performance: [],
  requestPinResponse: null,
  chargePinResponse: null,
  storedBundles: [],
  registrationInfoMsisdn: '',
  monthlyPrizeForLeaderboard: [],
  grandPrizeForLeaderboard: [],
  dailyPrizeForLeaderboard: [],
  weeklyPrizeForLeaderboard: [],
  monthlyWinnersForLeaderboard: [],
  dailyWinnersForLeaderboard: [],
  weeklyWinnersForLeaderboard: [],
  grandWinnersForLeaderboard: [],
  monthlyRankForLeaderboard: [],
  grandRankForLeaderboard: [],
  dailyRankForLeaderboard: [],
  weeklyRankForLeaderboard: [],
  availablePrizeTypes: [],
  showmodalForDefaultPrizeDetails: false,
  jwtInVuex: '',
  firstTimeEntry: false,
  userAuthorized: false,
  profilePath: false,
  bundleId: 0,
  bundleData: {
    numberOfGames: '',
    price: '',
    currencyCode: '',
    points: '',
  },
  themes: [],
  notifications: [],
  gameHistoryData: [],
  opponentDetails: {},
  gameDescriptionDetails: {},
  showHistory: false,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/index.js